document.addEventListener("DOMContentLoaded", function () {
  const productItems = document.querySelectorAll(".product-item__media");

  productItems.forEach(function (item) {
    const secondaryMedia = item.querySelector(".product-item__image--two_custom, .product-item__media--second");
    
    item.addEventListener("mouseenter", function () {
      secondaryMedia.classList.add("active");
    });

    item.addEventListener("mouseleave", function () {
      secondaryMedia.classList.remove("active");
    });
  });
});
